import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            <div>
              <span className="font-heading text-2xl md:text-3xl font-bold tracking-wide block mb-6">
                韩漫在线
              </span>
              <p className="text-foreground-400 text-sm leading-relaxed mb-6 max-w-xs">
                韩漫在线观看平台，提供免费下拉式韩国漫画全集。高清画质、流畅阅读，随时随地畅读您喜爱的韩漫作品。
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="QQ">
                  <i className="ri-qq-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-chat-smile-2-line"></i>
                </a>
              </div>
            </div>

            <div className="flex flex-col gap-6">
              <div>
                <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-3">联系我们</h4>
                <p className="text-foreground-400 text-sm leading-relaxed">北京市朝阳区望京SOHO</p>
                <p className="text-foreground-400 text-sm leading-relaxed">T1座1206室</p>
              </div>
              <div>
                <p className="text-foreground-400 text-sm leading-relaxed">电话：400-888-6666</p>
              </div>
              <div>
                <p className="text-foreground-400 text-sm leading-relaxed">邮箱：hello@wxctif.com</p>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-5">快速链接</h4>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <Link to="/category/romance" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">恋爱漫画</Link>
                <Link to="/category/fantasy" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">奇幻漫画</Link>
                <Link to="/category/action" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">动作漫画</Link>
                <Link to="/about" className="text-foreground-400 text-sm hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-foreground-500 text-xs">
              &copy; 2026 韩漫在线 manhuazx.com 版权所有
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">服务条款</a>
              <a href="#" className="text-foreground-500 text-xs hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}